// extracted by mini-css-extract-plugin
export default {"productCarousel":"i2-z"};